import * as React from 'react';
import cx from 'classnames';
import { LProps, withLocalization } from '../../utils/wrappers';
import { compose, Dispatch, bindActionCreators } from 'redux';
import { CompetitionUserScore, Entity, Competition } from '../../userApi';
import ScoreboardParticipants from '../../shared/ScoreboardParticipants';
import { connect } from 'react-redux';
import { State } from '../../redux/state';
import { makeCompetitionUserScoresForEntityPath } from '../../utils/routerHelper';

interface ManualProps {
  entity: Entity;
}

interface Props extends ManualProps {
  topUserScores: CompetitionUserScore[];
  competitionID: number;
  competition: Competition;
}

/** Right-column scoreboard: participants in this department/division. */
class Scoreboard extends React.Component<LProps<Props>> {
  public render() {
    const { topUserScores, t, entity, competitionID } = this.props;
    return (
      <div className="cc__scoreboard">
        <div className="cc__scoreboard__header">
          <div className={'cc__darktext'}>{t('Scoreboard')}</div>
          <div className="cc__scoreboard__header_tabs">
            <div
              role="button"
              className={cx('cc__scoreboard__header_tab', { active: true })}
            >{t('Participants')}</div>
          </div>
        </div>
        <ScoreboardParticipants
          viewAll={makeCompetitionUserScoresForEntityPath(competitionID, entity.id, t)}
          userScores={topUserScores}
          showEntityMetrics={entity.type === Entity.TypeEnum.Team}
          compact={entity.type === Entity.TypeEnum.Team}
        />
      </div>
    );
  }
}

const mapStateToProps = (state: State, ownProps: ManualProps): Partial<Props> => ({
  topUserScores: state.entityTopUserScores[ownProps.entity.id],
  competitionID: state.competition.id,
  competition: state.competition
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withLocalization('entity')
)(Scoreboard) as React.ComponentClass<ManualProps>;
